export type AppRole = 'client' | 'admin' | 'manager' | 'super_admin';

export function normalizeRole(role: string | null | undefined): AppRole {
  if (role === 'super_admin' || role === 'admin' || role === 'manager' || role === 'client') {
    return role;
  }
  return 'client';
}

/** Post-login / auth-guard destination for a given role */
export function getRoleDestination(role: string | null | undefined): string {
  const r = normalizeRole(role);
  if (r === 'super_admin') return '/super-admin-dashboard';
  if (r === 'admin' || r === 'manager') return '/admin-dashboard';
  return '/';
}

export function isStaffRole(role: string | null | undefined): boolean {
  const r = normalizeRole(role);
  return r === 'admin' || r === 'manager' || r === 'super_admin';
}

export function isSuperAdminRole(role: string | null | undefined): boolean {
  return normalizeRole(role) === 'super_admin';
}

/** Paths that require staff (admin / manager / super_admin) */
export const STAFF_ROUTE_PREFIXES = [
  '/admin-dashboard',
  '/deposits-withdrawals',
  '/transactions-management',
  '/payment-methods-management',
  '/user-management',
  '/account-tiers',
  '/performance-analytics',
] as const;

/** Paths that require super_admin only */
export const SUPER_ADMIN_ROUTE_PREFIXES = ['/super-admin-dashboard'] as const;

export function requiresStaff(pathname: string): boolean {
  return STAFF_ROUTE_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
}

export function requiresSuperAdmin(pathname: string): boolean {
  return SUPER_ADMIN_ROUTE_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
}
